{
  "alert.informative": "אינפורמטיבי",
  "alert.negative": "שלילי",
  "alert.notice": "הודעה",
  "alert.positive": "חיובי",
  "attachmentlist.nextAttachments": "הצג קבצים מצורפים הבאים",
  "attachmentlist.previousAttachments": "הצג קבצים מצורפים קודמים",
  "chat.newMessage": "הודעה חדשה",
  "chat.scrollToBottom": "גלול לתחתית",
  "messagefeedback.thumbDown": "תגובה גרועה",
  "messagefeedback.thumbUp": "תגובה טובה",
  "promptfield.aiDisclaimer": "התשובות נוצרות באמצעות בינה מלאכותית ועשויות להיות לא מדויקות. יש לבדוק אותן לפני השימוש.",
  "promptfield.aiUserGuidlines": "הנחיות למשתמשי בינה מלאכותית",
  "promptfield.attachments": "קבצים מצורפים",
  "promptfield.insertButton": "הוסף",
  "promptfield.label": "הנחיה",
  "promptfield.placeholder": "מוכנים להתחיל? שאלו שאלה, שתפו רעיון או הוסיפו משימה.",
  "promptfield.placeholder.small": "שאל כל דבר",
  "promptfield.stopButton": "עצור",
  "promptfield.submitButton": "שלח",
  "promptfield.uploading": "מעלה",
  "responsestatus.loading": "בטעינה…",
  "responsestatus.processing": "עיבוד...",
  "voicebutton.startListening": "התחל להקליט",
  "voicebutton.stopListening": "הפסק להקליט"
}
